module.exports = __webpack_public_path__ + "img/noRedEnvelopesImage.1db7a2b0.png";